<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo">
        <div class="envelope">📧</div>
        Email
      </div>
      <form @submit.prevent="login">
        <input
          type="email"
          v-model="email"
          placeholder="Email"
          required
          autocomplete="off"
        />
        <input
          type="password"
          v-model="pass"
          placeholder="Password"
          required
          autocomplete="off"
        />
        <template v-if="message == ''">
          <button type="submit" @click="login()">Login</button>

          <div class="footer">
            Forgot your password? <a href="#" @click="forgot()">Get a Hint</a>
          </div>
        </template>
        <template v-else>
          <div class="message">
            {{ message }} <a href="#" @click="back()"> Back</a>
          </div>
        </template>
      </form>
    </div>
  </div>
</template>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(to right, #004d99, #66b2ff);
}

.login-box {
  width: 300px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #004d99;
  margin-bottom: 20px;
}

.envelope {
  font-size: 32px;
  position: relative;
}

.spark {
  position: absolute;
  top: 5px;
  right: -5px;
  font-size: 18px;
}

input {
  width: 90%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #004d99;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.message {
  color: red;
}

button:hover {
  background-color: #003366;
}

.footer {
  margin-top: 15px;
  font-size: 14px;
}

a {
  color: #004d99;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>

<script>
import axios from "axios";
export default {
  name: "setupGame",
  props: {
    emailadd: String,
  },
  data() {
    return {
      teamName: "",
      nameError: false,
      email: "",
      pass: "",
      error: "",
      message: "",
    };
  },
  async mounted() {
    this.email = this.emailadd;

    if (
      localStorage.getItem("license") !== null &&
      localStorage.getItem("boxid") !== null
    ) {
      this.license = localStorage.getItem("datadash-license");
      this.boxid = localStorage.getItem("datadash-boxid");
      await this.GameSetup();
    }
  },
  methods: {
    forgot() {
      this.$emit("forgotpass", this.email);
    },
    back() {
      this.message = "";
    },
    async login() {
      console.log(this.email);

      if (
        this.email == "mmccarpyseaside@gmail.com" &&
        this.pass == "Tacos123!"
      ) {
        this.message = "Please Wait";
        this.stage = "email";
        localStorage.setItem("emailOK", true);
        this.$emit("login");
      } else {
        this.message = "Incorrect Username and/or Password";
      }
    },
  },
};
</script>


